/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signOutRedirect } from "../components/cognito/Authentication";
import ToasterContainer from "../components/general/ToasterContainer";
import logoFull from "../images/logo-full.png";
import userDefaultImage from "../images/user-default.png";
import { useAppDispatch, useAppSelector } from "../stores/hooks";
import { hasSession, setSession } from "../stores/sessionSlice";
import { RootState } from "../stores/store";
import "./AuthenticatedLayout.scss";
import { t } from "i18next";
import { useClarity } from "../hooks/useClarity";

interface IProps {
  children: React.ReactNode;
}

const AuthenticatedLayout = ({ children }: IProps): React.JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const session = useAppSelector((state: RootState) => state.session);
  const dispatch = useAppDispatch();

  useClarity(session?.id);

  useEffect(() => {
    if (!hasSession(session)) {
      const sessionData = localStorage.getItem("sessionData");

      if (!sessionData) {
        navigate("/", { state: { from: location.pathname } })
        return;
      }

      const sessionDataParsed = JSON.parse(sessionData) as ISession;

      dispatch(setSession(sessionDataParsed));
    } else {
      console.log("Session: ", session);
      // Recuperar dados do usuário
      // userInfo(session?.access_token, () => { })
    }
  }, []);

  const renderLoggedUserData = (): React.JSX.Element => {
    if (!session) return <></>;

    return (
      <div className="logged-user-data d-flex flex-row">
        <div className="user-info-container d-flex flex-column align-items-end pe-3 me-3">
          <span>{session.name}</span>
          <span>{session.email}</span>
        </div>
        <div
          className="user-image-container d-flex"
          onClick={() => navigate('/profile')}
          style={{ cursor: 'pointer' }}
          title="Clique para ver seu perfil"
        >
          {session.picture && (
            <img
              src={session.picture}
              alt="Usuário"
              key={session.picture}
              referrerPolicy="no-referrer"
            />
          )}
          {!session.picture && (
            <img
              src={userDefaultImage}
              alt="Usuário"
              key={userDefaultImage}
              referrerPolicy="no-referrer"
            />
          )}
        </div>
        <button onClick={() => signOutRedirect()} className="btn btn-sign-out">
          {t("authentication.signOut")}
        </button>
      </div>
    );
  };

  return (
    <div className="container-fluid p-0" id="auth-display">
      <nav className="navbar fixed-top p-3">
        <a className="navbar-brand p-0 m-0" href="/feedbacks">
          <img
            src={logoFull}
            className="logo-full d-block"
            alt="Feedback Canvas Logo"
          />
        </a>
        {renderLoggedUserData()}
      </nav>
      <div className="container-content px-3">
        {children}
        <ToasterContainer />
      </div>
    </div>
  );
};

export default AuthenticatedLayout;
